import React, { PureComponent } from 'react';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import Transition from './Transition';

const styles = () => ({
	dialogPaper: {
		overflow: 'scroll',
		maxWidth: '100%',
		width: 1100,
		height: '95%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	cell: {
		fontSize: '85%',
		verticalAlign: 'top',
		padding: '8px 12px',
	},
	pricingText: {
		border: '1px solid #eee',
		padding: 8,
		fontSize: '85%',
		maxWidth: 200,
		whiteSpace: 'pre-wrap',
	},
});

class ContractSubContractsPopup extends PureComponent {
	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const { classes, subContracts, open, fullScreen, isLoading, fuelContractId } = this.props;

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullScreen={fullScreen}
				maxWidth="lg"
				classes={{ paper: classes.dialogPaper }}
			>
				<DialogTitle>
					<div style={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
						<span>Sub Contracts for Contract #{fuelContractId}</span>
						<Button onClick={this.handleClose}>Close</Button>
					</div>
				</DialogTitle>
				<DialogContent style={{ height: '100%', paddingLeft: 20, paddingRight: 20 }}>
					{isLoading ? (
						<div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
							<CircularProgress />
						</div>
					) : _.isEmpty(subContracts) ? (
						<div style={{ color: '#888', fontStyle: 'italic', padding: 20 }}>
							No sub contracts found.
						</div>
					) : (
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell className={classes.cell}>Sub Contract #</TableCell>
									<TableCell className={classes.cell}>Name</TableCell>
									<TableCell className={classes.cell}>Product</TableCell>
									<TableCell className={classes.cell}>Prov. Pricing</TableCell>
									<TableCell className={classes.cell}>Final Pricing</TableCell>
									<TableCell className={classes.cell}>Station Costs</TableCell>
									<TableCell className={classes.cell}>Bulk Costs</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{subContracts.map((sc) => (
									<TableRow key={sc.fuelSubContractId}>
										<TableCell className={classes.cell}>
											<div style={{ display: 'flex', alignItems: 'center' }}>
												{sc.fuelSubContractId}
												<Tooltip title="Copy Sub Contract ID">
													<IconButton
														size="small"
														style={{ padding: 2, marginLeft: 4 }}
														onClick={() => {
															navigator.clipboard.writeText(String(sc.fuelSubContractId));
														}}
													>
														<FileCopyIcon style={{ fontSize: 13 }} />
													</IconButton>
												</Tooltip>
											</div>
										</TableCell>
										<TableCell className={classes.cell}>{sc.name || '—'}</TableCell>
										<TableCell className={classes.cell}>{sc.productType || '—'}</TableCell>
										<TableCell className={classes.cell}>
											{sc.provisionalPricing ? (
												<div className={classes.pricingText}>{sc.provisionalPricing}</div>
											) : (
												'—'
											)}
										</TableCell>
										<TableCell className={classes.cell}>
											{sc.finalPricing ? (
												<div className={classes.pricingText}>{sc.finalPricing}</div>
											) : (
												'—'
											)}
										</TableCell>
										<TableCell className={classes.cell} style={{ whiteSpace: 'nowrap' }}>
											{(sc.finalCalculatedCosts || []).map((entry) => (
												<div key={entry.startDate}>
													{moment(entry.startDate).format('MMM')}: {entry.cost || '—'}
												</div>
											))}
										</TableCell>
										<TableCell className={classes.cell} style={{ whiteSpace: 'nowrap' }}>
											{(sc.finalCalculatedCosts || []).map((entry) => (
												<div key={entry.startDate}>
													{moment(entry.startDate).format('MMM')}: {entry.bulkCost || '—'}
												</div>
											))}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					)}
				</DialogContent>
			</Dialog>
		);
	}
}

ContractSubContractsPopup.propTypes = {
	classes: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func,
	fullScreen: PropTypes.bool.isRequired,
	fuelContractId: PropTypes.number,
	subContracts: PropTypes.array,
	isLoading: PropTypes.bool,
};

export default _.flow([withStyles(styles), withMobileDialog()])(ContractSubContractsPopup);
